import React from 'react';
import { useNavigate } from 'react-router-dom';
import BrandWordmark from './BrandWordmark';
import PoweredByTrAingle from './PoweredByTrAingle';
import './InfoPages.css';

function PublicSiteFooter() {
  const navigate = useNavigate();

  return (
    <footer className="public-site-footer">
      <div className="public-site-footer-shell">
        <div className="public-site-footer-intro">
          <div className="public-site-footer-brand">
            <BrandWordmark className="public-site-footer-brand-mark" />
            <PoweredByTrAingle className="public-site-footer-powered-by" />
          </div>
          <p className="public-site-footer-copy">
            Secure document redaction for teams that need clean workflows, trustworthy controls, and modern compliance signals.
          </p>
          <p className="public-site-footer-meta">
            Trial access available — contact sales for enterprise deployment and BAA options.
          </p>
        </div>
        <nav className="public-site-footer-links" aria-label="Footer navigation">
          <button type="button" onClick={() => navigate('/security')}>Security</button>
          <button type="button" onClick={() => navigate('/privacy-policy')}>Privacy</button>
          <button type="button" onClick={() => navigate('/terms')}>Terms</button>
          <button type="button" onClick={() => navigate('/user-agreement')}>User Agreement</button>
          <button type="button" onClick={() => navigate('/support')}>Support</button>
          <button type="button" onClick={() => navigate('/contact')}>Contact</button>
          <a href="/#trust-transparency">How your data is protected</a>
        </nav>
      </div>
    </footer>
  );
}

export default PublicSiteFooter;
